<div class="selector-container">
  <div class="select-custom"
    [ngClass]="{ 'focused' : focused }"
    (click)="toggleFocus()"
    (mouseenter)="onMouseOver()"
    (mouseleave)="onMouseLeft()">
    @if (selectedIndex.length == 0) {
      <div class="selected-item placeholder-text"
        >
        {{ placeHolder }}
      </div>
    }
    @if (selectedIndex.length > 0) {
      <div class="selected-items"
        >
        @for (i of selectedIndex; track i) {
          <div (click)="$event.stopPropagation();">
            {{ items[i].name }}
            <img src="assets/img/icons/cancel_white.png"
              alt="cancel-icon"
              (click)="removeItem(i,$event)">
            </div>
          }
          @if ( selectedIndex.length -1 > 0) {
            <p class="select-count"
              >
              {{ '+' + (selectedIndex.length -1) }}
            </p>
          }
        </div>
      }
      <span class="arrow-down"
        (click)="toggleFocus()"
      [ngClass]="{ 'arrow-focused' : hovered || focused }"></span>
    </div>
    @if (focused) {
      <div class="select-custom-options"
        (mouseleave)="hideDropdown()"
        >
        @if (showSelectAll) {
          <div (click)="toggleSelectAll()">
            <input type="checkbox"
              class="checkbox"
              [(ngModel)]="selectAll"
              (ngModelChange)="onSelectAll()"/>
              <div>Select All</div>
            </div>
          }
          @for (i of items; track i; let index = $index) {
            @if ( i.rating > 0) {
              <div (click)="onItemSelected(index)">
                <input type="checkbox"
                  [checked]=" selectedIndex.includes(index)"/>
                  @for ( x of [].constructor(i.rating); track  x) {
                    <img    class="star-rating"
                      alt="star-icon"
                      src="assets/img/icons/cb_star_active.svg">
                    }
                    @for ( x of [].constructor(maxRating-i.rating); track  x) {
                      <img    class="star-rating"
                        alt="star-icon"
                        src="assets/img/icons/cb_star_inactive.svg">
                      }
                    </div>
                  }
                  @if ( i.rating == 0) {
                    <div (click)="onItemSelected(index)">
                      <input type="checkbox"
                        [checked]=" selectedIndex.includes(index)"/>
                        <div>No Rating</div>
                      </div>
                    }
                  }
                </div>
              }
            </div>
